module.exports = __webpack_public_path__ + "static/media/1-2-alzbetu-navstivila.66d128d8.jpg";